<template>
    <div>
      <h2>{{ message }}</h2>
      <button @click="$emit('close')">Close from Inside</button>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      message: {
        type: String,
        required: true
      }
    }
  };
  </script>
  